function UserIcon({ width = '32', height = '32.722' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32.722"
    >
      <g id="user" transform="translate(-24.165 -3.278)">
        <g
          id="Group_43348"
          data-name="Group 43348"
          transform="translate(24.165)"
        >
          <g id="Group_43347" data-name="Group 43347" transform="translate(0)">
            <path
              id="Path_29651"
              data-name="Path 29651"
              d="M117.837,14.863a7.265,7.265,0,0,0,7.045-7.431,7.055,7.055,0,1,0-14.09,0A7.265,7.265,0,0,0,117.837,14.863Z"
              transform="translate(-101.837 3.278)"
              fill="#d40e15"
            />
            <path
              id="Path_29652"
              data-name="Path 29652"
              d="M56.1,254.8a9.01,9.01,0,0,0-.932-1.755,11.5,11.5,0,0,0-7.985-5.182,1.669,1.669,0,0,0-1.175.293,9.654,9.654,0,0,1-11.673,0,1.486,1.486,0,0,0-1.175-.293,11.421,11.421,0,0,0-7.985,5.182,10.389,10.389,0,0,0-.932,1.755.913.913,0,0,0,.04.794,16.718,16.718,0,0,0,1.094,1.672,15.74,15.74,0,0,0,1.865,2.173,24.532,24.532,0,0,0,1.865,1.672,17.955,17.955,0,0,0,23.914-1.672,19.122,19.122,0,0,0,1.865-2.173,14.692,14.692,0,0,0,1.094-1.672A.73.73,0,0,0,56.1,254.8Z"
              transform="translate(-24.165 -228.876)"
              fill="#3b4150"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default UserIcon;
